import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';

import Divider from '@material-ui/core/Divider';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import PreviewMap from './previewMap';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './checkoutForm';

class OrderItems extends Component {
  state = {
    subTotal: 0,
    tax: 0,
    total: 0,
  };

  componentDidMount = () => {
    const { order } = this.props;

    var count = 0;

    order.map((item) => (count += parseFloat(item.price)));
    var totals = (parseFloat(count) + parseFloat(count * 0.05)).toFixed(2);

    this.setState({
      subTotal: parseFloat(count).toFixed(2),
      tax: parseFloat(count * 0.05).toFixed(2),
      total: totals,
    });
  };

  render() {
    //const stripePromise = loadStripe("pk_test_TYooMQauvdEDq54NiTphI7jx")
    const stripePromise = loadStripe(
      'pk_live_51HS97AKeS05Fm6cJolKg0eKAiTLaByLpcZlgaTQjk0MCGubwTxbloQNlXyw4jKjlxZfnQExGyM38dELTHxe3rr8D00vkuwvnVw'
    );
    this.props.setTotal(this.state.total);

    const { order } = this.props;

    return (
      <div style={{ maxWidth: '410px', margin: '0 auto' }} id="entrees">
        {order.length === 0 ? (
          <div>
            <div>Your cart is empty</div>
            <div style={{ marginTop: '20vh' }}>
              <Divider style={{ marginBottom: '2vh' }} />
            </div>
          </div>
        ) : (
          <div>
            <div style={{ display: 'flex' }}>
              <a href="/">
                <img alt="up22" src="/smallup2.png" style={{ height: '8vh' }} />
              </a>

              <Typography style={{ margin: '0 auto', padding: '3vh' }}>
                Chuys
              </Typography>
            </div>
            <Divider style={{ height: '1px !important' }} />
            <div style={{ display: 'flex', padding: '5px' }}>
              <PreviewMap />
              <Button style={{ width: '100%' }}> Pick up location </Button>
            </div>
            <div style={{}}>
              {' '}
              <Typography
                style={{
                  fontSize: '0.9rem',
                  background: 'rgb(242 243 244)',
                  fontWeight: '400',
                  padding: '10px',
                }}
                variant="h6"
              >
                Items
              </Typography>
            </div>
          </div>
        )}
        {order.map((item) => (
          <div style={{ paddingTop: '2vh' }} key={item.item}>
            <div>
              <Typography
                variant="h6"
                style={{
                  paddingLeft: '30px',
                  fontSize: '16px',
                  fontWeight: '450',

                  fontFamily:
                    'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                }}
              >
                {'1   '} {item.item}
              </Typography>
              <Typography
                style={{
                  textAlign: 'right',
                  marginTop: '-4vh',
                  color: 'rgb(118, 118, 118)',
                  paddingRight: '5vw',
                  fontSize: '16px',
                  fontWeight: '500',
                  lineHeight: '20px',
                  fontFamily:
                    'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                }}
              >
                {item.price}
              </Typography>

              <Typography
                variant="body2"
                style={{
                  paddingLeft: '45px',
                  paddingTop: '1vh',
                  color: 'rgb(118, 118, 118)',
                  fontSize: '12px',
                  fontWeight: '450',
                  lineHeight: '20px',
                  fontFamily:
                    'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                }}
              >
                {item.toppings.toString()}
              </Typography>

              <Divider />
            </div>
          </div>
        ))}

        {order.length === 0 ? (
          ''
        ) : (
          <div>
            <Divider />
            <Typography
              variant="h6"
              style={{
                paddingTop: '1.5vh',
                fontSize: '12px',
                fontWeight: '450',
                paddingLeft: '30px',
                color: 'rgb(118, 118, 118)',
                fontFamily:
                  'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
              }}
            >
              Subtotal
            </Typography>
            <Typography
              style={{
                textAlign: 'right',
                marginTop: '-3vh',
                color: 'rgb(118, 118, 118)',
                paddingRight: '5vw',
                fontSize: '12px',
                fontWeight: '500',
                lineHeight: '20px',
                fontFamily:
                  'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
              }}
            >
              {this.state.subTotal}
            </Typography>

            <Typography
              variant="h6"
              style={{
                paddingLeft: '30px',

                fontSize: '12px',
                fontWeight: '450',
                color: 'rgb(118, 118, 118)',
                lineHeight: '1.9',

                fontFamily:
                  'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
              }}
            >
              Estimated fees and tax
            </Typography>
            <Typography
              style={{
                textAlign: 'right',
                marginTop: '-3vh',
                color: 'rgb(118, 118, 118)',
                paddingRight: '5vw',
                fontSize: '12px',
                fontWeight: '500',
                lineHeight: '20px',
                fontFamily:
                  'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
              }}
            >
              {this.state.tax}
            </Typography>
            <Typography
              style={{
                fontSize: '13px',
                fontWeight: 'bold',
                paddingBottom: '3vh',
                paddingLeft: '30px',
              }}
              variant="h6"
            >
              Total
            </Typography>
            <Typography
              style={{
                textAlign: 'right',
                marginTop: '-6vh',
                color: 'rgb(118, 118, 118)',
                paddingRight: '5vw',
                fontSize: '12px',
                fontWeight: '500',
                lineHeight: '20px',
                fontFamily:
                  'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
              }}
            >
              {this.state.total}
            </Typography>
            <div style={{ paddingTop: '2vh', paddingBottom: '1vh' }}>
              {' '}
              <Typography
                style={{
                  fontSize: '0.9rem',
                  background: 'rgb(242 243 244)',
                  fontWeight: '400',
                  padding: '10px',
                }}
                variant="h6"
              >
                Payment Method
              </Typography>
            </div>
            <Elements stripe={stripePromise}>
              <CheckoutForm />
            </Elements>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    setTotal: (total) => {
      dispatch({ type: 'SET_TOTAL', total: total });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderItems);
